import * as PipelineActions from "./pipelineActions";

export default PipelineActions;
